import Form from "../form/Form";
import { edit } from '../../slices/usersGroupSlice';
import { useParams } from "react-router-dom";
import { appUrl } from "../../utils/fetch";

function User() {
    const { id } = useParams();
    return (
        <Form 
            inputs={{
                name: {
                    label: "name",
                    field: "text"
                }
            }}
            columns={2}
            stateName="usersGroup"
            dispatchFunc={edit}
            title={id !== "new" ? "Edit Users Group" : "Create Users Group"}
            api={`${appUrl}/api/users-group`}
            navbar
            detailId={id}
        />
    );
}

export default User;